/**
 * SALEコレクション ON 時、グローバルナビの /collections/sale リンクに赤丸バッジを付与
 */
(function () {
  function isSaleNavLink(link, salePath) {
    if (!link || !link.getAttribute) {
      return false;
    }
    var href = link.getAttribute('href') || '';
    return href === salePath || href === salePath + '/' || href.indexOf(salePath + '?') === 0;
  }

  function isInGlobalNav(link) {
    return !!(
      link.closest('header') ||
      link.closest('.header') ||
      link.closest('.shopify-section-group-header-group') ||
      link.closest('.menu-drawer') ||
      link.closest('.header__inline-menu') ||
      link.closest('nav.header__inline-menu')
    );
  }

  function markSaleNavLinks() {
    var cfg = window.FACETT_SALE;
    if (!cfg || !cfg.active) {
      return;
    }

    document.documentElement.classList.add('facett-sale-active');

    var salePath = cfg.collectionPath || '/collections/sale';
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (!isSaleNavLink(link, salePath) || !isInGlobalNav(link)) {
        return;
      }
      link.classList.add('facett-sale-nav-badge-target');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markSaleNavLinks);
  } else {
    markSaleNavLinks();
  }
})();
